interface RightTriangleIconProps {
  width?: string;
  height?: string;
}

export function RightTriangleIcon({
  width = '19',
  height = '41',
  ...rest
}: RightTriangleIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 19 41'
      fill='none'
      {...rest}
    >
      <path
        d='M16.5935 17.0084C18.4883 18.9505 18.4883 22.0495 16.5935 23.9916L-1.79217e-06 41L0 -8.74228e-07L16.5935 17.0084Z'
        fill='white'
      />
    </svg>
  );
}
